export default {
  namespaced: true,
  state: {
    videoPlayId: ''
  },
  mutations: {
    setVideoPlayId(state, data) {
      state.videoPlayId = data
    }
  }
}
